import {
	PRESENTATION_BOLD_AUDIO_TAG,
	PRESENTATION_SOFT_EMPHASIS_AUDIO_TAG,
	type PresentationRichTextInline,
	type PresentationRichTextMark,
	type PresentationRichTextNode,
	type PresentationRichTextV1,
} from "./presentation-rich-text-v1";

function pickEmphasisTag(
	marks: PresentationRichTextMark[] | undefined,
): string | null {
	if (!marks || marks.length === 0) {
		return null;
	}
	if (marks.includes("bold")) {
		return PRESENTATION_BOLD_AUDIO_TAG;
	}
	if (marks.includes("italic") || marks.includes("underline")) {
		return PRESENTATION_SOFT_EMPHASIS_AUDIO_TAG;
	}
	return null;
}

function inlinesToTaggedScript(
	inlines: PresentationRichTextInline[] | undefined,
): string {
	if (!inlines || inlines.length === 0) {
		return "";
	}
	let out = "";
	for (const node of inlines) {
		if (node.type === "hardBreak") {
			out += "\n";
			continue;
		}
		const tag = pickEmphasisTag(node.marks);
		if (tag && node.text.trim().length > 0) {
			out += `${tag} ${node.text}`;
		} else {
			out += node.text;
		}
	}
	return out;
}

function blockToTaggedScript(block: PresentationRichTextNode): string {
	if (block.type === "paragraph") {
		return inlinesToTaggedScript(block.content);
	}
	if (block.type === "listItem") {
		return (block.content ?? []).map(blockToTaggedScript).join("\n");
	}
	if (block.type === "bulletList" || block.type === "orderedList") {
		const items = block.content ?? [];
		return items
			.map((item, index) => {
				const body = blockToTaggedScript(item).trim();
				if (body.length === 0) {
					return "";
				}
				const prefix =
					block.type === "orderedList" ? `${index + 1}. ` : "";
				return `${prefix}${body}`;
			})
			.filter((line) => line.length > 0)
			.join("\n");
	}
	return "";
}

/**
 * Map presentation marks → ElevenLabs-style audio tags while preserving
 * speakable word order (tags are prefixes, not word replacements).
 */
export function presentationRichTextToNarrationScript(
	doc: PresentationRichTextV1,
): string {
	const parts = (doc.content ?? [])
		.map(blockToTaggedScript)
		.map((part) => part.trim())
		.filter((part) => part.length > 0);
	return parts.join("\n\n");
}
